// Ozlo Announcement Bar Handler
// Extracted from ozlo-main.js
// Clones announcement bar into sticky header

function initAnnouncementBar() {
  const announcementSection = document.querySelector('.shopify-section.announcement-bar-section');
  const stickyHeader = document.querySelector('sticky-header');

  if (announcementSection && stickyHeader && !stickyHeader.querySelector('.announcement-bar-container')) {
    const utilityBar = announcementSection.querySelector('.utility-bar');

    if (utilityBar) {
      // Create container for cloned announcement bar
      const container = document.createElement('div');
      container.className = 'announcement-bar-container';

      // Clone utility bar
      const clonedBar = utilityBar.cloneNode(true);
      container.appendChild(clonedBar);

      // Insert at beginning of sticky header
      stickyHeader.insertBefore(container, stickyHeader.firstChild);

      // Hide original utility bar
      utilityBar.style.opacity = '0';
      utilityBar.style.height = '0';
      utilityBar.style.overflow = 'hidden';
      utilityBar.setAttribute('aria-hidden', 'true');
      utilityBar.classList.add('hidden');

      // Update header height CSS variable
      const headerHeight = stickyHeader.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }
  }
}

// Initialize on page load
window.addEventListener('load', () => {
  initAnnouncementBar();

  // If in Shopify design mode, refresh periodically
  if (window.Shopify && window.Shopify.designMode) {
    setInterval(initAnnouncementBar, 1000);
  }
});
